import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Group, Text } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useCallback } from "react";
import { useAppAction } from "../../hooks/redux.js";
import { selectLayer } from "../../reducers/layersReducer.js";
import { useCaptureEvent } from "../../components/StyleEditorContext.js";
import { Event } from "../../constants/events.js";
export const LayerConfigHeader = ({ layer }) => {
    const captureEvent = useCaptureEvent();
    const select = useAppAction(selectLayer);
    const handleClose = useCallback((event) => {
        event.stopPropagation();
        captureEvent(Event.CloseLayerConfig);
        select(null);
    }, [select, captureEvent]);
    return (_jsxs(Group, { p: "xs", gap: "xs", h: "50px", align: "center", justify: "space-between", children: [_jsx(Text, { fw: 500, size: "sm", children: layer.id }), _jsx(IconX, { onClick: handleClose })] }));
};
